import { VideoPlay } from "./VideoPlay";

export default VideoPlay;
